import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

const DaysIndicator = ({ scale = 0, text }) => (
	<div className="DaysIndicator">
		<Typography
			variant="body1"
			sx={{
				paddingBottom: 0.5,
			}}
		>
			{text}
		</Typography>
		<div className="ProgressWrapper">
			<div className="ProgressWrapper-progressBar" style={{ width: `${scale}%` }} />
			<div className="ProgressWrapper-stripes" style={{ width: `${100 - scale}%` }} />
		</div>
	</div>
);

DaysIndicator.propTypes = {
	scale: PropTypes.number,
	text: PropTypes.string,
};

export default DaysIndicator;
